import { createAsyncThunk } from "@reduxjs/toolkit";

import { appealsService } from "../services/appealsService";
import { atpUsersService } from "../services/atpUsersService";
import { cpdSubmissionService } from "../services/cpdSubmissionService";
import { atpActivitiesService } from "../services/atpActivitiesService";
import { membershipService } from "../services/membershipService";
import { renewalService } from "../services/renewalService";
import moment from "moment";

export const fetchAppeals = createAsyncThunk(
    "applicants/fetchAppeals",
    async (
        {
            page,
            limit,
            start_date,
            end_date,
            certificate_type,
            full_name,
            filter_status,
            registered_from,
            registered_to,
            technology_field,
            identity_number,
            payment_from,
            payment_to,
            search,
            board_approval_from,
            board_approval_to,
            registration_no,
            email,
        },
        thunkAPI
    ) => {
        try {
            const response = await appealsService.getAppeals({
                page,
                limit,
                certificate_type,
                start_date: start_date ? moment(start_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                end_date: end_date ? moment(end_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                full_name,
                registered_from: registered_from ? moment(registered_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                registered_to: registered_to ? moment(registered_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                board_approval_from: board_approval_from ? moment(board_approval_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                board_approval_to: board_approval_to ? moment(board_approval_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                technology_field,
                identity_number,
                payment_from: payment_from ? moment(payment_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                payment_to: payment_to ? moment(payment_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                search,
                registration_no,
                filter_status,
                email,
            });
            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
        }
    }
);

export const fetchUserAppeal = createAsyncThunk("applicants/fetchUserAppeal", async (id, thunkAPI) => {
    try {
        const response = await appealsService.getAppeal(id);
        return response?.data?.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
    }
});

export const fetchAtpUsers = createAsyncThunk(
    "applicants/fetchAtpUsers",
    async ({ page, limit, status, search, company_name, registered_from, registered_to, start_date, end_date, payment_from, payment_to, payment_status, full_name }, thunkAPI) => {
        try {
            const response = await atpUsersService.getAtpUsers({
                page,
                limit,
                status,
                search,
                company_name,
                start_date: start_date ? moment(start_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                end_date: end_date ? moment(end_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                full_name,
                registered_from: registered_from ? moment(registered_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                registered_to: registered_to ? moment(registered_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                payment_from,
                payment_to,
                payment_status,
                full_name,
            });
            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
        }
    }
);

export const fetchAtpUsersCounts = createAsyncThunk(
    "applicants/fetchAtpUsersCounts",
    async ({ page, limit, status, search, company_name, registered_from, registered_to, start_date, end_date, payment_from, payment_to, payment_status, full_name }, thunkAPI) => {
        try {
            const response = await atpUsersService.getAtpUsersCounts({
                status,
                search,
                company_name,
                start_date: start_date ? moment(start_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                end_date: end_date ? moment(end_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                full_name,
                registered_from: registered_from ? moment(registered_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                registered_to: registered_to ? moment(registered_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                payment_from,
                payment_to,
                payment_status,
                full_name,
            });
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
        }
    }
);

export const getCpdSubmissionList = createAsyncThunk(
    "cpdSubmission/getCpdSubmissionList",
    async (
        {
            page,
            limit,
            status,
            search,
            certificate_type,
            registered_from,
            registered_to,
            start_date,
            end_date,
            full_name,
            identity_number,
            technology_field,
            organization,
            type_of_cpd,
            submission_date,
        },
        thunkAPI
    ) => {
        try {
            const response = await cpdSubmissionService.getCpdSubmissionList({
                page,
                limit,
                status,
                search,
                certificate_type,
                start_date: start_date ? moment(start_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                end_date: end_date ? moment(end_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                full_name,
                registered_from: registered_from ? moment(registered_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                registered_to: registered_to ? moment(registered_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                identity_number,
                technology_field,
                organization,
                type_of_cpd,
                submission_date: submission_date ? moment(submission_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
            });
            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
        }
    }
);

export const fetchATPActivities = createAsyncThunk(
    "cpdSubmission/fetchATPActivities",
    async (
        {
            page,
            limit,
            cpd_status,
            status,
            search,
            full_name,
            certificate_type,
            registered_from,
            registered_to,
            start_date,
            end_date,
            title,
            identity_number,
            technology_field,
            company_name,
            type_of_cpd,
            submission_date,
        },
        thunkAPI
    ) => {
        try {
            const response = await atpActivitiesService.getAtpActivities({
                page,
                limit,
                cpd_status,
                status,
                full_name,
                search,
                certificate_type,
                start_date: start_date ? moment(start_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                end_date: end_date ? moment(end_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                registered_from: registered_from ? moment(registered_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                registered_to: registered_to ? moment(registered_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                title,
                identity_number,
                technology_field,
                company_name,
                type_of_cpd,
                submission_date,
            });
            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
        }
    }
);

export const fetchATPActivitiesCounts = createAsyncThunk(
    "cpdSubmission/fetchATPActivitiesCounts",
    async (
        {
            cpd_status,
            status,
            search,
            full_name,
            certificate_type,
            registered_from,
            registered_to,
            start_date,
            end_date,
            title,
            identity_number,
            technology_field,
            company_name,
            type_of_cpd,
            submission_date,
        },
        thunkAPI
    ) => {
        try {
            const response = await atpActivitiesService.getAtpActivitiesCounts({
                cpd_status,
                status,
                full_name,
                search,
                certificate_type,
                start_date: start_date ? moment(start_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                end_date: end_date ? moment(end_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                registered_from: registered_from ? moment(registered_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                registered_to: registered_to ? moment(registered_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                title,
                identity_number,
                technology_field,
                company_name,
                type_of_cpd,
                submission_date,
            });
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
        }
    }
);

export const getMemberShipList = createAsyncThunk(
    "cpdSubmission/getMemberShipList",
    async (
        {
            page,
            limit,
            search,
            certificate_type,
            registered_from,
            registered_to,
            start_date,
            end_date,
            full_name,
            identity_number,
            technology_field,
            membership_status,
            board_approval_from,
            board_approval_to,
            email,
            filter_status,
            registration_no,
            payment_from,
            payment_to,
        },
        thunkAPI
    ) => {
        try {
            const response = await membershipService.getMemberShipList({
                page,
                limit,
                search,
                certificate_type,
                start_date: start_date ? moment(start_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                end_date: end_date ? moment(end_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                full_name,
                registered_from: registered_from ? moment(registered_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                registered_to: registered_to ? moment(registered_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                payment_from: payment_from ? moment(payment_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                payment_to: payment_to ? moment(payment_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                board_approval_from: board_approval_from ? moment(board_approval_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                board_approval_to: board_approval_to ? moment(board_approval_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                identity_number,
                membership_status,
                technology_field,
                email,
                filter_status,
                registration_no,
            });
            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
        }
    }
);

export const getRenewalCertificates = createAsyncThunk(
    "renewals/getRenewalCertificates",
    async ({ page, limit, search, certificate_type, registered_from, registered_to, start_date, end_date, full_name, identity_number, technology_field, renewal_status }, thunkAPI) => {
        try {
            const response = await renewalService.getRenewalCertificates({
                page,
                limit,
                search,
                certificate_type,
                start_date: start_date ? moment(start_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                end_date: end_date ? moment(end_date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                full_name,
                registered_from: registered_from ? moment(registered_from).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                registered_to: registered_to ? moment(registered_to).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
                identity_number,
                renewal_status,
                technology_field,
            });
            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data); // Reject with error message
        }
    }
);
